import { Component, ViewEncapsulation, inject, signal } from "@angular/core";
import { ConfirmationService, PrimeTemplate } from "primeng/api";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { AbstractListController } from "src/app/common/abstract-list.component";
import {
  ACTIVE_STATE_LIST,
  PARAM_CLIENTS_PATH,
} from "src/app/constants/constants";
import { Clients } from "src/app/models/clients";
import { ClientsService } from "src/app/services/clients.service";
import { Bind } from "primeng/bind";
import { Drawer } from "primeng/drawer";

import { FormsModule } from "@angular/forms";
import { InputText } from "primeng/inputtext";
import { Select } from "primeng/select";
import { DatePicker } from "primeng/datepicker";
import { ButtonDirective } from "primeng/button";
import { TableModule } from "primeng/table";
import { Tag } from "primeng/tag";
import { NgxPaginationModule } from "ngx-pagination";
import { Card } from "primeng/card";
import { ConfirmDialog } from "primeng/confirmdialog";
import { Toast } from "primeng/toast";
import { TranslatePipe } from "@ngx-translate/core";

import { DynamicFiltersComponent } from "../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../i18n/t.pipe";
@Component({
  standalone: true,
  selector: "app-manage-clients",
  templateUrl: "./manage-clients.component.html",
  styleUrl: "./manage-clients.component.less",
  encapsulation: ViewEncapsulation.None,
  imports: [TPipe, 
    DynamicFiltersComponent,
    Bind,
    Drawer,
    PrimeTemplate,
    FormsModule,
    InputText,
    Select,
    DatePicker,
    ButtonDirective,
    RouterLink,
    TableModule,
    Tag,
    NgxPaginationModule,
    Card,
    ConfirmDialog,
    Toast,
    TranslatePipe,
  ],
})
export class ManageClientsComponent extends AbstractListController<
  Clients,
  any
> {
  protected clientsService: ClientsService;
  protected confirmationService: ConfirmationService;

  title = "Clienti";
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);
  readonly client = signal<Clients>(undefined);
  readonly roomDialog = signal<boolean>(false);

  constructor() {
    const clientsService = inject(ClientsService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      clientsService,
      confirmationService,
      router,
      route,
      PARAM_CLIENTS_PATH,
    );
    this.clientsService = clientsService;
    this.confirmationService = confirmationService;

    this.cols.set([
      {
        field: "is_active",
        header: "Attivo",
        type: "select",
        option: ACTIVE_STATE_LIST,
      },

      { field: "name", header: "Nome" },
      { field: "city", header: "Città" },
      { field: "email", header: "Email" },
      { field: "phone", header: "Cellulare" },
    ]);

    this.colsFilter.set([
      {
        field: "is_active",
        icon: "pi-power-off",
        header: "Stato",
        type: "select",
        option: ACTIVE_STATE_LIST,
      },

      { field: "name", icon: "pi-user", header: "Nome", type: "string" },
      { field: "surname", icon: "pi-user", header: "Cognome", type: "string" },
      { field: "email", icon: "pi-envelope", header: "Email", type: "string" },
      { field: "phone", icon: "pi-phone", header: "Cellulare", type: "string" },
      { field: "city", icon: "pi-map-marker", header: "Città", type: "string" },
    ]);
  }

  initials(c: Clients): string {
    return (
      `${c?.name ?? ""} ${c?.surname ?? ""}`
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase() || "?"
    );
  }

  open(client: Clients) {
    this.edit(client);
  }

  edit(client: Clients) {
    this.client.set({ ...client });
    this.roomDialog.set(true);
  }
}
